import { memo, useCallback, useState } from "react";
import { Colors } from "../../../../utils/colors";
import { Event } from "@markit/common.types";
import TextareaAutosize from "react-textarea-autosize";
import { Icon } from "@iconify/react";
import CircularProgress from "@mui/material/CircularProgress";
import { API } from "../../../../API";

type CreateProductTitleDescriptionProps = {
  tempProductData: Event;
  setTempProductData: (tempProductData: Event) => void;
  titlePlaceholder: string;
  descriptionPlaceholder: string;
};

// The title and description section of the product creation flow
const CreateProductTitleDescription = (
  props: CreateProductTitleDescriptionProps
) => {
  const {
    tempProductData,
    setTempProductData,
    titlePlaceholder,
    descriptionPlaceholder,
  } = props;
  const [generatingTitle, setGeneratingTitle] = useState(false);

  const styles = {
    inputContainer: {
      color: Colors.BLACK,
      border: "none",
      resize: "none",
      padding: 0,
    },
  };

  const onGenerateTitle = useCallback(async () => {
    setGeneratingTitle(true);
    try {
      const { title } = await API.events.generateTitle({
        event: tempProductData,
      });
      if (title) {
        setTempProductData({ ...tempProductData, title });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setGeneratingTitle(false);
    }
  }, [setTempProductData, tempProductData]);

  return (
    <div className="ColumnNormal" style={{ gap: 14 }}>
      <div className="AlignedRow" style={{ gap: 10 }}>
        <div
          className="Centering"
          style={{
            flexShrink: 0,
            pointerEvents: generatingTitle ? "none" : "auto",
            cursor: "pointer",
          }}
          onClick={onGenerateTitle}
        >
          {generatingTitle ? (
            <CircularProgress size={20} style={{ color: Colors.BLUE5 }} />
          ) : (
            <Icon
              icon={"ion:sparkles"}
              height={20}
              style={{ color: Colors.BLUE5 }}
            />
          )}
        </div>
        <TextareaAutosize
          value={tempProductData.title}
          placeholder={titlePlaceholder}
          onChange={(e) =>
            setTempProductData({ ...tempProductData, title: e.target.value })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          className="post-title-input"
          style={
            {
              ...styles.inputContainer,
              flex: 1,
              minWidth: 0,
              fontSize: 32,
              fontWeight: 600,
              "--placeholder-color": Colors.GRAY3,
            } as any
          }
          maxLength={200}
        />
      </div>
      <TextareaAutosize
        value={tempProductData.description}
        placeholder={descriptionPlaceholder}
        onChange={(e) =>
          setTempProductData({
            ...tempProductData,
            description: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        className="post-title-input sectionTitle"
        style={
          {
            ...styles.inputContainer,
            color: Colors.GRAY3,
            "--placeholder-color": Colors.GRAY3,
          } as any
        }
        maxLength={200}
      />
    </div>
  );
};

export default memo(CreateProductTitleDescription);
